
































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Toast, Notify } from 'vant'

const retreatCouponModule = namespace('retreatCoupon')

@Component({
  components: {}
})
export default class FaceCouponsSure extends Vue {
  defaultImg: any = require('@/image/default.png')
  couponInfo: any = null;
  random: any = ''
  orderNo: any = ''
  tradeAmount: any = ''
  verification: boolean = false
  verificationShow: boolean = false
  show: boolean = false;
  
  mounted() {
    this.setActive()
    this.getInfo()
  }
  setActive() {
    this.$store.commit('retreatCoupon/setSelectStep', 2)
  }
  async getInfo() {
    const { success } = await this.$store.dispatch(
      'giftCard/gitGiftCardInfo',
      {
        giftCardInstanceId: this.$route.query.couponInstanceQrCode
      }
    )
    if (success) {
        this.couponInfo = success.data
    }
  }
  sendCode(){
      this.$store.dispatch(
      'giftCard/gitMsgCode',
      {
          mobile: this.couponInfo.giftCardInstanceMobile,
          businessId: this.$global.parentBusinessEntityId,
          activityId: this.couponInfo.giftCardActivityId
      }
    )
    this.verification = true
    this.verificationShow = true
  }
  finish(){
    this.verification = false 
  }
  sureCoupon() {
    if (!this.random) {
      Notify({ type: 'warning', message: '请输入验证码' });
      return
    }
    if (!this.orderNo) {
      Notify({ type: 'warning', message: '请输入订单号' });
      return
    }
    if (!this.tradeAmount) {
      Notify({ type: 'warning', message: '请输入核销金额' });
      return
    }
    this.show = true
  }

  async confirm(){
      let param = {
        giftCardFlowType: 3,
        giftCardId: this.couponInfo.giftCardId,
        giftCardInstanceCardInstanceId: this.couponInfo.giftCardInstanceCardInstanceId,
        operationType: 0,
        orderNo: this.orderNo,
        random: this.random,
        tradeAmount: this.tradeAmount*100,
        userCid: '',
        writeOffAccountId: this.$global.uId,
        writeOffBusinessEntityId: this.$global.tenantId,
        mobile: this.couponInfo.giftCardInstanceMobile,
        writeSessionId: ""
    }
    const { error, success } = await this.$store.dispatch(
      'giftCard/writeoffCard',
      param
    )
    if (success) {
        param.operationType = 1
        param.writeSessionId = success.data.writeSessionId
        const res = await this.$store.dispatch('giftCard/writeoffCard',param)

        if (res.success) {
            Toast('核销成功')
            this.$store.commit('giftCard/setSuccess', res.success.data)
            setTimeout(() => {
                this.$router.push(`/writeoffCard/success`)
            }, 100)
        } else {
            Toast(res.error.msg)
        }
      sessionStorage.setItem(
        'retreatCouponMsg',
        JSON.stringify(this.couponInfo)
      )
    } else {
      Toast(error.msg)
    }
  }
}
